// auth module
const AUTH = '/auth';
export const LOGIN_URL = '/auth/admin/signin';
export const FORGET_PASSWORD_URL = `${AUTH}/forget-password`;
export const LOGOUT_URL = `${AUTH}/admin/logout`;
// export const CHANGE_PASSWORD_URL = '/user/admin/changePassword';
export const CHANGE_PASSWORD_URL = '/subAdmin/changePassword';
export const VERIFYTOKEN = `/auth/verifyToken`;
export const RESET_PASSWORD_URL = '/auth/reset-password';
export const SET_DEVICE_TOKEN_URL = '/auth/admin/adminDeviceIdStore';

// dashboard
export const GET_DASHBOARD_DATA_URL = '/dashboard/admin';

export const GET_DASHBOARD_EARNING_DATA_URL = '/dashboard/admin/chart';

// userData
const USER = '/user';
export const USER_DATA_URL = `${USER}/me`;
export const EDIT_PROFILE_URL = `/subAdmin/updateAdmin`;

// TimeSlote

export const TIME_SLOTS = '/timeslots';
export const GET_ALL_TIME_SLOTS_URL = `${TIME_SLOTS}`;
export const ADD_TIME_SLOTS_URL = `${TIME_SLOTS}`;
export const EDIT_TIME_SLOTS_URL = `${TIME_SLOTS}`;
export const DELETE_TIME_SLOTS_URL = `${TIME_SLOTS}`;
export const GET_TIME_SLOTS_BY_ID_URL = `${TIME_SLOTS}`;
export const UPDATE_TIME_SLOTS_STATUS_URL = `${TIME_SLOTS}/isActive`;

// geoFence
export const GEOFENCE = '/geofences';
export const GET_ALL_GEOFENCE_LIST_URL = `${GEOFENCE}`;
export const ADD_GEOFENCE_URL = `${GEOFENCE}`;
export const EDIT_GEOFENCE_URL = `${GEOFENCE}`;
export const GET_GEOFENCE_URL_BY_ID = `${GEOFENCE}`;
export const DELETE_GEOFENCE_URL = `${GEOFENCE}`;
export const STATUS_UPDATE_GEOFENCE_URL = `${GEOFENCE}/status`;

// Holiday
export const HOLIDAY = '/governmentHolidays';
export const GET_ALL_HOLIDAYLIST_URL = `${HOLIDAY}`;
export const ADD_HOLIDAYLIST_URL = `${HOLIDAY}`;
export const EDIT_HOLIDAYLIST_URL = `${HOLIDAY}`;
export const DELETE_HOLIDAYLIST_URL = `${HOLIDAY}`;
export const GET_HOLIDAYLIST_URL_BY_ID = `${HOLIDAY}`;

// ROle & Permission

export const ROLE_PERMISSION = '/role';
export const ROLE_PERMISSION_MODULE_URL = '/modules';
export const ADD_ROLE_PERMISSION_URL = `${ROLE_PERMISSION}`;
export const EDIT_ROLE_PERMISSION_URL = `${ROLE_PERMISSION}`;
export const GET_ROLE_PERMISSION_URL_BY_ID = `${ROLE_PERMISSION}/`;
export const GET_ROLE_PERMISSION_LIST_URL = `${ROLE_PERMISSION}`;
export const DELETE_ROLE_PERMISSION_LIST_URL = `${ROLE_PERMISSION}`;
// export const GET_ROLE_PERMISSION_LIST_URL = `/modules`;

// App Settings

export const GET_APP_SETTING_URL = '/appSetting';
export const UPDATE_APP_SETTING_URL = '/appSetting';


export const GET_APP_DELIVERY_FEE_SETTING_URL = '/deliveryFee';
export const UPDATE_APP_DELIVERY_FEE_SETTING_URL = '/deliveryFee';

// contact us

export const GET_CONTACT_US_LIST_URL = '/contactUs';
export const REPLY_CONTACT_US_LIST_URL = '/contactUs';

// Product

export const PRODUCT = '/product';
export const GET_ALL_PRODUCT_LIST_URL = `${PRODUCT}`;
export const ADD_PRODUCT_URL = `${PRODUCT}`;
export const EDIT_PRODUCT_URL = `${PRODUCT}`;
export const GET_PRODUCT_URL_BY_ID = `${PRODUCT}`;
export const DELETE_PRODUCT_URL = `${PRODUCT}`;
export const STATUS_UPDATE_PRODUCT_URL = `${PRODUCT}/status`;

// order

export const ORDER = '/orders';
export const GET_ALL_ORDER_LIST_URL = `${ORDER}/getAllByUser`;
export const GET_ORDER_DETAIL_BY_ID_URL = `${ORDER}`;
export const DELETE_ORDER_URL = `${ORDER}/cancelOrder`;
export const GET_ALL_DELAY_ORDER_LIST_URL = `${ORDER}/getAllByUser`;

// Map

export const GET_ALL_DRIVER_LOCATION_URL = '/driver/adminSide/latlong';

// Report

export const GET_ALL_CUSTOMER_LIST_URL = '/customer';
export const GET_ALL_DRIVERS_LIST_URL = '/reports/driver';
export const GET_ALL_ORDERS_LIST_URL = '/reports/orders';
export const GET_ALL_REPEAT_ORDER_LIST_URL = 'reports/repeated';
export const GET_ALL_ORDER_ORDERS_LEAKAGE_AND_DELAYS_LIST_URL =
	'/reports/OrdersLeakageAndDelays';
export const GET_ALL_VENDORS_LIST_URL = '/reports/vendor';
export const GET_ALL_PRODUCT_LIST_REPORT_URL = '/product';
export const GET_ALL_TRANSACTION_LIST_URL = '/reports/transaction';
// email Template

export const GET_ALL_EMAIL_TEMPLATE_URL = '/emailTemplate';
export const GET_EMAIL_TEMPLATE_BY_ID_URL = '/emailTemplate';
export const UPDATE_EMAIL_TEMPLATE_BY_ID_URL = '/emailTemplate';

// cms

export const GET_ALL_CMS_LIST_URL = '/cms';
export const UPDATE_CMS_BY_ID_URL = '/cms/update';
export const GET_CMS_BY_ID_URL = '/cms';

// google map

export const GET_DRIVER_CURRENT_LOCATION = '/driver/location';
export const GET_POLILINE_PATH = '/orders/map/path';

// notification List

export const GET_NOTIFICATION_LIST = '/notification';
export const READ_NOTIFICATION = '/notification/read';

// sub Admin

export const SUB_ADMIN = '/subAdmin';
export const GET_ALL_SUB_ADMIN_LIST_URL = `${SUB_ADMIN}`;
export const ADD_SUB_ADMIN_URL = `${SUB_ADMIN}`;
export const EDIT_SUB_ADMIN_URL = `${SUB_ADMIN}`;
export const DELETE_SUB_ADMIN_URL = `${SUB_ADMIN}`;
export const GET_SUB_ADMIN_URL_BY_ID = `${SUB_ADMIN}`;
export const ROLES = `role/all/options`;

export const GET_NEW_JWT_TOKEN = `/auth/admin/refresh`;

export const UPDATE_SUB_ADMIN_STATUS_URL = `${SUB_ADMIN}/status`;

// User
export const USERS = '/customer';
export const ADD_USER_URL = `${USERS}`;
export const GET_USER_URL = `${USERS}`;
export const DELETE_USER_URL = `${USERS}`;
export const USER_STATUS_UPDATE_URL = `${USERS}/status`;
export const USER_ORDER_LIST = `/orders/userOrders`;

// vendor

export const VENDOR = '/vendor';
export const GET_ALL_VENDOR_URL = `${VENDOR}`;
export const ADD_VENDOR_URL = `${VENDOR}`;
export const EDIT_VENDOR_URL = `${VENDOR}/update`;
export const DELETE_VENDOR_URL = `${VENDOR}`;
export const GET_VENDOR_BY_ID_URL = `${VENDOR}`;
export const VENDOR_STATUS_UPDATE_URL = `${VENDOR}/status`;
export const VENDOR_APPROVAL_UPDATE_URL = `${VENDOR}/approval`;

// driver

export const DRIVER = 'driver';
export const GET_ALL_DRIVER_LIST = `${DRIVER}`;
export const GET_DRIVER_BY_ID = `${DRIVER}`;
export const UPDATE_DRIVER_BY_ID = `${DRIVER}/update`;
export const ADD_NEW_DRIVER = `${DRIVER}/create`;
export const UPDATE_DRIVER_APPROVAL_URL = `${DRIVER}/profile/status`;
export const UPDATE_DRIVER_AVALIBITY_URL = `${DRIVER}/online/status`;
export const UPDATE_DRIVER_STATUS_URL = `${DRIVER}/isActive`;
export const DELETE_DRIVER_URL = `${DRIVER}/delete`;
export const GET_ORDER_DETAIL_OF_DRIVER = `/orders/driversOrders`;
export const GET_ORDER_DETAIL_OF_VENDOR = `/orders/vendorOrders`;
export const GET_DRIVER_RATING = '/ratings';
export const GET_DRIVER_ASSIGN_TIME_SLOT_URL = '/driver/assignTime';
export const UPDATE_DRIVER_ASSIGN_TIME_SLOT_URL = '/driver/assignTime';

// settlement

export const GET_ALL_SETTLEMENT_LIST_URL = '/settlement';
export const SETTLEMENT_AMOUNT_FORM_URL = '/settlement';

// payment

export const GET_ALL_PAYMENT_LIST_URL = '/vendor/adminPaymentList';
export const UPDATE_PAYMENT_STATUS_URL = '/vendor/paymentStatus';


// Subscription Plan for driver

export const SUBSCRIPTIONPLAN = '/driverSubscriptionPlan';
export const GET_ALL_SUBSCRIPTIONPLAN_LIST_URL = `${SUBSCRIPTIONPLAN}`;
export const ADD_SUBSCRIPTIONPLAN_URL = `${SUBSCRIPTIONPLAN}`;
export const EDIT_SUBSCRIPTIONPLAN_URL = `${SUBSCRIPTIONPLAN}`;
export const GET_SUBSCRIPTIONPLAN_URL_BY_ID = `${SUBSCRIPTIONPLAN}`;
export const DELETE_SUBSCRIPTIONPLAN_URL = `${SUBSCRIPTIONPLAN}`;
export const UPDATE_DRIVER_PLAN_STATUS_URL = `${SUBSCRIPTIONPLAN}/status`;


// Subscription Plan for vendor

export const VENDOR_SUBSCRIPTIONPLAN = '/vendorSubscriptionPlan';
export const GET_ALL_VENDOR_SUBSCRIPTIONPLAN_LIST_URL = `${VENDOR_SUBSCRIPTIONPLAN}`;
export const ADD_VENDOR_SUBSCRIPTIONPLAN_URL = `${VENDOR_SUBSCRIPTIONPLAN}`;
export const EDIT_VENDOR_SUBSCRIPTIONPLAN_URL = `${VENDOR_SUBSCRIPTIONPLAN}`;
export const GET_VENDOR_SUBSCRIPTIONPLAN_URL_BY_ID = `${VENDOR_SUBSCRIPTIONPLAN}`;
export const DELETE_VENDOR_SUBSCRIPTIONPLAN_URL = `${VENDOR_SUBSCRIPTIONPLAN}`;
export const UPDATE_VENDOR_PLAN_STATUS_URL = `${VENDOR_SUBSCRIPTIONPLAN}/status`;